import {createBrowserRouter, Outlet} from "react-router-dom";

import {StudentRoute} from "@/router/StudentRoute";
import GatewaySelectorPage from "@/pages/gateway/gatewaySelectorPage";
import PrivateRoute from "@/router/PrivateRoot";
import HomePage from "@/pages/homepage/homePage";
import {AuthMobileCheckPage} from "@/pages/auth/authMobileCheckPage";
import AuthLogoutPage from "@/pages/auth/authLogoutPage";
import {TeacherRoute} from "@/router/TeacherRoute";
import {AdminRoute} from "@/router/AdminRoute";
import Page404 from "@/components/layout/Page404";
import {LmsRoute} from "@/router/LmsRoute";
import {OldRoute} from "@/router/OldRoute";
import {LoginAs} from "@/components/LoginAs/LoginAs";
import SelectChildren from "@/pages/gateway/childer/SelectChildren";
import ErrorPage from "@/components/error/ErrorPage";

const RouteList = [
    {
        path: `/`,
        element: <HomePage/>,
        errorElement: <ErrorPage/>
    },
    {
        path: `/login-as`,
        element: <LoginAs/>,
        errorElement: <ErrorPage/>
    },
    {
        path: '/auth',
        errorElement: <ErrorPage/>,
        element: <Outlet/>,
        children: [
            {
                index: true,
                element: <AuthMobileCheckPage/>,
            },
            {
                path: `logout`,
                element: <AuthLogoutPage/>,
            },
        ],
    },
    {
        path: '/gateway',
        errorElement: <ErrorPage/>,
        element: <PrivateRoute module={'gateway'}/>,
        children: [
            {
                index: true,
                element: <GatewaySelectorPage/>,
            },
            {
                path: `children`,
                element: <SelectChildren/>,
            }
        ],
    },
    ...LmsRoute,
    ...StudentRoute,
    ...TeacherRoute,
    ...AdminRoute,
    ...OldRoute,
    {
        path: '*',
        errorElement: <ErrorPage/>,
        element: <Page404/>,
    },
]


const router = createBrowserRouter(RouteList)

export default router
